import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faIdCard } from "@fortawesome/free-solid-svg-icons";
import { Button, Spinner, InputGroup, InputGroupText, InputGroupAddon, FormGroup, Input } from "reactstrap";
import api from "../../services/client/api";
import {
  StepContainer,
  ModalWrapper,
  StepTexth4,
  CloseButton,
  SubText,
  ButtonGroup
} from "./styles";

const ActiveTries = ({ token, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [cpf, setCpf] = useState("");

  // Função para aplicar máscara de CPF
  const handleCpfChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 11) value = value.slice(0, 11);

    let formatted = value;
    if (value.length > 9) {
      formatted = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else if (value.length > 6) {
      formatted = value.replace(/(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");
    } else if (value.length > 3) {
      formatted = value.replace(/(\d{3})(\d{1,3})/, "$1.$2");
    }

    setCpf(formatted);
  };

  const handleUpdate = async (type) => {
    const cleanCpf = cpf.replace(/\D/g, "");

    if (!cleanCpf || cleanCpf.length !== 11) {
      alert("Informe um CPF válido");
      return;
    }

    setLoading(true);

    try {
      await api().log().updateLog(token, { username: cleanCpf, type });
      alert("Ativação das tentativas de biometria realizada com sucesso!");
      onClose();
    } catch (err) {
      console.error(err);
      alert("Erro ao reativar tentativas");
    }

    setLoading(false);
  };

  return (
    <ModalWrapper>
      <CloseButton onClick={onClose}>
        <FontAwesomeIcon icon={faTimesCircle} />
      </CloseButton>

      <StepContainer>
        <StepTexth4>Reativar Tentativas de Biometria</StepTexth4>

        <SubText>
          Informe o CPF do paciente que deseja reativar as tentativas
        </SubText>


          <FormGroup>
            <span
              style={{
                display: "block",
                fontWeight: 650,
                fontSize: "15px",
                color: "#6c757d",
                textAlign: "left",
              }}
            >
              CPF:
            </span>

            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <FontAwesomeIcon icon={faIdCard} />
                </InputGroupText>
              </InputGroupAddon>

              <Input
                type="text"
                value={cpf}
                placeholder="CPF"
                maxLength={14} // considerando máscara xxx.xxx.xxx-xx
                onChange={handleCpfChange}
              />
            </InputGroup>
          </FormGroup>
     

        <ButtonGroup>
          <Button
            color="primary"
            disabled={loading}
            onClick={() => handleUpdate(1)}
          >
            {loading ? <Spinner size="sm" /> : "Ativar Tentativas"}
          </Button>
        </ButtonGroup>
      </StepContainer>
    </ModalWrapper>
  );
};

export default ActiveTries;